export default {
domainInvalid: {
  siteUnavailableTitle: "Sitio No Disponible",
  siteUnavailableDesc: "Este sitio no está disponible en este momento.",
  contactAdmin: "Comuníquese con el administrador.",
  serverErrorTitle: "Servicio No Disponible",
  serverErrorDesc: "No se pudo conectar con el servidor, inténtelo de nuevo más tarde.",
  serverErrorTip: "Se reconectará automáticamente cuando el servidor vuelva a estar disponible.",
  notAuthorizedTitle: "Dominio No Autorizado",
  notAuthorizedDesc: "El dominio actual no está autorizado para acceder a este servicio.",
  checking: "Verificando...",
  retry: "Reintentar",
  reload: "Recargar",
  reloading: "Recargando...",
  checkingDomain: "Verificando dominio...",
  authorizedRedirecting: "Dominio autorizado, redirigiendo...",
  stillNotAuthorized: "El dominio sigue sin estar autorizado",
  reconnecting: "Reconectando..."
}
};
